import { defineStore } from 'pinia';
import { Notification } from '@/types/notification';

export const useNotificationStore = defineStore('notification', {
  state: () => ({
    notifications: {} as Record<string, Notification>,
    globalNotification: null as Notification | null,
  }),
  actions: {
    addNotification(notification: Notification) {
      if (notification.section) {
        this.notifications = { ...this.notifications, [notification.section]: notification };
      } else {
        this.globalNotification = notification;
      }
    },
    clearNotification(section?: string) {
      if (section) {
        const updated = { ...this.notifications };
        delete updated[section];
        this.notifications = updated;
      } else {
        this.globalNotification = null;
        this.notifications = {};
      }
    },
  },
});
